export default {
    watch: {
        tableWidth(n, o) {
            if (n != o) {
                this.pw(this.num);
            }
        }
    },
    data() {
        return {
            tableWidth: document.documentElement.clientWidth || document.body.clientWidth || 0
        }
    },
    methods: {
        pw(num) {
            let v = this;
            if (num != undefined) {
                var domWidth = v.minDomWidth;
                if (domWidth == undefined) domWidth = 1280;
                if (typeof num == "number") {
                    v.orderColumn[num].width = v.tableWidth <= domWidth ? v.minWidth : null;
                } else if (typeof num == 'object') {
                    num.forEach((n, i) => {
                        v.orderColumn[n].width = v.tableWidth <= domWidth ? v.minWidth[i] : null;
                    })

                }

            }
        },
        tableResize(fn) {
            var originFn = window.onresize
            window.onresize = function() {
                originFn && originFn()
                fn()
            }
        }
    },
    mounted() {
        let v = this;
        v.tableResize(function() {
            v.tableWidth = document.documentElement.clientWidth || document.body.clientWidth || 0;
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/mixin/table_mixin.js